import React from 'react';

import layoutStyles from '~/components/layouts/layouts.module.scss';

const IntroText = () => {
  return (
    <div style={{ textAlign: 'left' }}>
      <h1 className={layoutStyles.sidebarTitleVariant}>
        Confirm the area you want treated
      </h1>
    </div>
  );
};

export default IntroText;
